import { ShapeType } from '@/services/shape';
import { getTextColorReg } from '@/watch-renderer/utils/string.utilts';
import { TextString } from '@/services/shape/attributes/text';
export function DataItemTextLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem
) {
  layer.type = ShapeType.Text;
  const {
    fontWeight,
    fontId,
    fontSize = '24',
    radius = 100,
    letterSpace = 0,
    rotation = 0,
    w = 0,
    span = 0,
    string = '',
    color = '#ffffff',
    startAngle = 0
  } = layerAst.attrsMap;
  const reverseText = Number(span) < 0 ? true : false;
  const _startAngle = Number(startAngle);
  layer.attrs = {
    ...layerAst.attrsMap,
    ...layer.attrs,
    fontId: fontId?.toLowerCase() ?? 'misans',
    fontWeight: fontWeight?.toLowerCase() ?? 'normal',
    fontSize: Number(fontSize),
    radius: Number(radius),
    letterSpace: Number(letterSpace),
    rotation: Number(rotation),
    sizeContent: ['1023', 'size_content'].includes(String(w)),
    reverseText,
    startAngle: reverseText ? _startAngle * -1 : _startAngle,
    arcSpan: Math.abs(Number(span))
  };

  // 处理string
  const textColorModeReg = getTextColorReg();
  const isColorMode = textColorModeReg.test(string);

  const textStrings: TextString[] = [];

  if (isColorMode) {
    textColorModeReg.lastIndex = -1;
    const arr = [...(string + '').matchAll(textColorModeReg)];

    let sourceIndex = -1;
    arr.forEach((item) => {
      const res = item[0];
      if (!res) return;
      const arr = res.split(/(?<=#[0-9a-zA-Z]{6,8})\s/);
      const [color, text] = arr;

      const reg = /%[.]?([0]?)([\d]?)([d|f|s])/g;
      const _string = text.replace(reg, '&').replace('%%', '%');
      _string.split('').forEach((_char) => {
        if (_char == '&') {
          sourceIndex++;
          const sourceKey =
            layerAst.children[sourceIndex]?.attrsMap?.['source'];
          if (!sourceKey) return;
          textStrings.push({
            isSource: true,
            value: sourceKey,
            color
          });
        } else {
          textStrings.push({
            isSource: false,
            value: _char,
            color
          });
        }
      });

      // const isSource = /%[.]?([0]?)([\d]?)([d|f|s])/g.test(text);
      // if (isSource) sourceIndex++;
      // textStrings.push({
      //   isSource: isSource,
      //   color,
      //   value: isSource
      //     ? layerAst.children[sourceIndex]?.attrsMap?.['source']
      //     : text
      // });
    });
  } else {
    // 如果使用数据源
    if (layerAst.children.length) {
      const reg = /%[.]?([0]?)([\d]?)([d|f|s])/g;
      const _string = string.replace(reg, '&').replace('%%', '%');
      let sourceIndex = -1;
      _string.split('').forEach((_char) => {
        if (_char == '&') {
          sourceIndex++;
          const sourceKey =
            layerAst.children[sourceIndex]?.attrsMap?.['source'];
          if (!sourceKey) return;
          textStrings.push({
            isSource: true,
            value: sourceKey,
            color
          });
        } else {
          textStrings.push({
            isSource: false,
            value: _char,
            color
          });
        }
      });
    } else {
      textStrings.push({
        color,
        value: string,
        isSource: false
      });
    }
  }
  layer.attrs.strings = textStrings;
}
